import React, { useState } from "react";
import editIcon from "../assets/editIcon.png";
import OptionMenu from "./OptionMenu";
import { useNavigate } from "react-router-dom";
import "react-circular-progressbar/dist/styles.css";
import useOrderLoadItemsFromApiStore from "../store/orderLoadItemsFromApiStore";
import { formatarValor } from "../components/OrderTable";
import { GrAlert } from "react-icons/gr";
import { CiCircleCheck } from "react-icons/ci";

const CargasTable = ({ cargas }) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(null);
  const { orderLoadItemsFromApi } = useOrderLoadItemsFromApiStore();
  const handleNavigateDetails = (id, index) => {
    navigate(`/cargas/${id}/detalhes/${index}`);
  };

  const toggleMenu = (index) => {
    setIsOpen(isOpen === index ? null : index);
  };

  const year = new Date().getFullYear();

  const getNamesById = (id) => {
    const items = orderLoadItemsFromApi.filter(
      (item) => item.order_load_id === id
    );

    let text =
      items.length > 0
        ? items.map((item) => item.name).join(", ")
        : "Itens não encontrados";

    return text.length > 100 ? text.substring(0, 150) + "..." : text;
  };

  const dateFormatted = (date) => {
    return new Date(date).toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  return (
    <div className="px-4 pb-4 pt-12 md:pt-6 bg-[#F2F2F2]  rounded-md mt-4 text-boldGray opacity-90 custom-scrollbar overflow-visible overflow-y-auto max-h-[680px]">
      <table className="w-full table-auto border-collapse overflow-visible">
        <thead className="min-h-[44px] border-b border-lightGray text-base ">
          <tr className="uppercase bold text-base md:text-xs xl:text-base">
            <th className="md:px-2 px-4 py-2"></th>
            <th className="md:px-2 px-4 py-2">Código</th>
            {/* <th className="md:px-2 px-4 py-2">Fornecedor</th> */}
            <th className="md:px-2 px-4 py-2">Itens</th>
            <th className="md:px-2 px-4 py-2">ETA</th>
            <th className="md:px-2 px-4 py-2"></th>
            <th className="md:px-2 px-4 py-2 ">Valor Total</th>
            {/* <th className="md:px-2 px-4 py-2">Valor Total</th> */}
          </tr>
        </thead>
        <tbody className="space-y-4">
          <tr>
            <td className="h-[20px]"></td>
            <td className="h-[20px]"></td>
            <td className="h-[20px]"></td>
            <td className="h-[20px]"></td>
            <td className="h-[20px]"></td>
            <td className="h-[20px]"></td>
            <td className="h-[20px]"></td>
            <td className="h-[20px]"></td>
          </tr>
          {cargas.map((carga, index) => (
            <React.Fragment key={index}>
              <tr
                className="text-center bg-[#E7E7E7] w-full cursor-pointer h-[64px] md:text-xs xl:text-base overflow-visible"
                onClick={() => handleNavigateDetails(carga.id, index + 1)}
              >
                <td className="" onClick={(e) => e.stopPropagation(carga.id)}>
                  <button onClick={() => toggleMenu(index)} className="">
                    <img src={editIcon} alt="" />
                  </button>
                  {isOpen === index && <OptionMenu setter={setIsOpen} />}
                </td>
                <td className="  font-bold">{`C00${index + 1}-${year}`}</td>
                {/* <td className=" ">{cargas.fornecedor ?? 0}</td> */}
                <td className=" max-w-[550px]">{getNamesById(carga.id)}</td>
                <td className=" ">{dateFormatted(carga.loading_date)}</td>
                <td className=" ">
                  {carga.pending_issue?.length > 0 ? (
                    <div className="flex items-center -ml-6 justify-center gap-2 text-red-500">
                      <GrAlert className=" h-6 w-6" />
                      <p className="font-semibold">
                        {carga.pending_issue?.length} Pendência
                        {carga.pending_issue?.length > 1 && "s"}
                      </p>
                    </div>
                  ) : (
                    <div className="flex items-center justify-center gap-2 text-green-500">
                      <CiCircleCheck className=" h-6 w-6" />
                      <p className="font-semibold">Sem pendências</p>
                    </div>
                  )}
                </td>
                <td className=" ">
                  {formatarValor(carga.outgoing_total, "USD")}
                </td>
                <td className="  flex justify-evenly items-center h-[64px]">
                  {Object.keys(carga.status ?? 0).map((statusKey) => (
                    <div
                      key={statusKey}
                      className={` lg:px-3 lg:py-2 xl:px-4 xl:py-2  md:px-2 md:py-1 ml-1 rounded-full md:text-xs lg:text-base text-base font-bold  ${
                        carga.status[statusKey]
                          ? "bg-[#77E066] text-white"
                          : "bg-[#FF7474] text-white"
                      }`}
                    >
                      {statusKey}
                    </div>
                  ))}
                </td>
              </tr>
              {index !== carga.length - 1 && (
                <tr>
                  <td className="h-[10px]"></td>
                </tr>
              )}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default CargasTable;
